import { darken } from "@clockwise/client-commons/src/util/color";
import { colors, greys, helpers } from "@clockwise/web-commons/src/styles/color.styles";
import { CSSProperties } from "@material-ui/core/styles/withStyles";

const googleButton: CSSProperties = {
  backgroundColor: colors.googleBlue,
  color: greys.white,
  padding: 0,
  fontFamily: "inherit",
  "&:hover": {
    backgroundColor: darken(colors.googleBlue, 0.05),
  },
};

const raisedButton: CSSProperties = {
  "&:hover": {
    backgroundColor: helpers.opacity(greys.darkestGrey, 0.1),
  },
};

const rippleRoot: CSSProperties = {
  color: helpers.opacity(greys.darkestGrey, 0.3),
};

export const styles = {
  googleButton,
  raisedButton,
  rippleRoot,
};
